import { FilterDropDown } from './components/FilterDropDown/FilterDropDown'
import { Container } from './TableFilter.ui'
import { TFilterStateFn, TFilterTypes } from './types'
import { handleFilterList } from './utils'
import { FilterParams, FilterVariant } from 'types'
import DateFilterInput from './components/Inputs/DateFilterInput/DateFilterInput'
import NumberFilterInput from './components/Inputs/NumberFilterInput/NumberFilterInput'
import RangeFilterInput from './components/Inputs/RangeFilterInput/RangeFilterInput'
import StringFilterInput from './components/Inputs/StringFilterInput/StringFilterInput'
import RangeNumberFilter from './components/Inputs/RangeNumberFilter/RangeNumberFilter'
import SelectFilterInput from './components/Inputs/SelectFilterInput/SelectFilterInput'

interface Props {
  value: any
  handleFilterState: TFilterStateFn
  columnId: string
  filterType: TFilterTypes
  filterParams?: FilterParams
  handleApplyGlobalFilters?: () => void
}

const renderDateInput = (
  filterVariant: FilterVariant,
  filterType: TFilterTypes
) => {
  if (filterVariant === 'string') {
    return StringFilterInput
  }

  if (filterVariant === 'number' && filterType === 'between') {
    return RangeNumberFilter
  }

  if (filterVariant === 'number') {
    return NumberFilterInput
  }

  if (filterVariant === 'date' && filterType === 'between') {
    return RangeFilterInput
  }

  if (filterVariant === 'date') {
    return DateFilterInput
  }

  if (filterVariant === 'select') {
    return SelectFilterInput
  }

  return StringFilterInput
}

export function TableFilter({
  value,
  columnId,
  filterType,
  handleFilterState,
  filterParams,
  handleApplyGlobalFilters,
}: Props) {
  const FilterComponent = renderDateInput(
    filterParams.filterVariant,
    filterType
  )

  const startAdornment = (
    <FilterDropDown
      value={filterType}
      onChange={(typeVal) => handleFilterState(columnId, typeVal, value)}
      options={handleFilterList(filterParams.filterVariant)}
    />
  )

  return (
    <Container>
      <FilterComponent
        value={value}
        filterType={filterType}
        filterParams={filterParams}
        handleFilterState={handleFilterState}
        columnId={columnId}
        startAdornment={startAdornment}
        handleApplyGlobalFilters={handleApplyGlobalFilters}
      />
    </Container>
  )
}
